export default __webpack_public_path__ + "static/media/logo-dark.d68e621c.svg";